import React, {useState, useEffect} from 'react';
import TitleWithBar from 'components/TitleWithBar';
import PubSub from 'services/PubSub/';
import UserInfoService from "services/AccountInfo/";
import { clientUpdateDrawer, methodToSla } from 'config';
import { actionsType, scheduledList } from 'config/constants';
import StorageService from 'services/StorageService';
import WalletService from 'services/Wallet';
import AddressService from 'services/Address/';
import CustomSelect from "components/CustomSelect";
import PaymentMethodPrimeItem from 'components/Drawers/DrawerPaymentMethodPrime/ContainerPaymentMethodPrime/PaymentMethodPrimeList/PaymentMethodPrimeItem';
import AddCardsContent from 'components/Drawers/DrawerPaymentMethodPrime/ContainerPaymentMethodPrime/AddCardsContent';
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox'
import ListService from 'services/AccountLists';
import Loader from 'components/Loader';
import AddressFactory from 'factories/Address'
import style from './style.scss'; //NOSONAR

const frequencyList = scheduledList.scheduleFrequency
const scheduleDeliveryDay = scheduledList.scheduleDeliveryDay
const startDateList = scheduledList.scheduleStartDay
const type = { delivery: 'seller-1-sla-DespachoaDomicilio' }
let schedulePhone = ''

const ScheduledList= (props) => {
    const [listName, setListName] = useState(props?.data?.listName);
    const [userPhone, setUserPhone] = useState('');
    const [userData, setUserData] = useState({});

    const [address, setAddress] = useState('');
    const [addressId, setAddressId] = useState('')
    const [fullAddress, setFullAddress] = useState({})

    const [salesChannel, setSalesChannel] = useState(null)

    const [frequency, setFrequency] = useState(frequencyList[0]);
    const [deliveryDaySelected, setDeliveryDaySelected] = useState(scheduleDeliveryDay[0])
    const [startDate, setStartDate] = useState(startDateList[0]);
    const [shippingWindows, setShippingWindows] = useState([]);
    const [shippingWindowsPerDay, setShippingWindowPerDay] = useState()
    const [shippingWindowSelected, setShippingWindowSelected] = useState({value: null, label: null})
    const [daysOfWeek, setDaysOfWeek] = useState()

    const [cardsList, setCardsList] = useState(null);
    const [selectedCard, setSelectedCard] = useState({})
    const [authorization, setAuthorization] = useState(false);
    const [isLoading, setIsLoading] = useState(true)

    const listId = props?.data?.listId

    useEffect(() => {
        getUserInfo()
        getAddress()
        getCardsList()

        setIsLoading(false)
    }, [])

    useEffect(() => {
        if (fullAddress?.addressId) {
            getShippingWindows()
        }
    }, [fullAddress, addressId])

    const getShippingWindows = () => {
        AddressService.getSalesChannel(fullAddress?.geoCoordinate[1], fullAddress?.geoCoordinate[0])
            .then(_saleschannel => {
                setSalesChannel(_saleschannel.sc)
                return AddressService.getShippingWindows(fullAddress, _saleschannel.sc, methodToSla[type.delivery])
                    .then(_shippingWindows => {
                        const daysOfWeek = _shippingWindows?.deliveryScheduleSettings?.dayOfWeekForDelivery
                        const daysFormated = daysOfWeek.map((item, index) => scheduleDeliveryDay[index])
                        const _shippingWindowsPerDay = daysOfWeek?.[0]?.deliveryRanges?.map((item, index) => formatHour(item, index))

                        setDaysOfWeek(daysOfWeek)
                        setShippingWindows(daysFormated) 
                        setShippingWindowPerDay(_shippingWindowsPerDay)
                        setShippingWindowSelected(_shippingWindowsPerDay[0])
                    })
            })
    }

    const formatHour = (item, index) => ({
        value: index,
        label: `${item.startTime.slice(0, -3)} a ${item.endTime.slice(0, -3)} | $${item.listPrice}`,
    })

    const changeListName = (event) => {
        setListName(event.target.value)  
    }

    const getUserInfo = () => {
        UserInfoService.getUser()
            .then(results => {
                setUserData(results);
                setUserPhone(schedulePhone ? schedulePhone : results.homePhone);
            });
    }

    const getAddress = () => {
        if (StorageService.getSecureItem('address')) {
            const _address = StorageService.getSecureItem('address')

            setAddress(AddressFactory.getFullAddress(_address))
            setAddressId(_address.addressId)
            setFullAddress(_address)
        } else {
            AddressService.getAll().then(results => {
                setAddress(AddressFactory.getFullAddress(results[0]))
                setAddressId(results[0]?.addressId)
                setFullAddress(results[0])
            })
        }
    }

    const updateAddress = () => {
        PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_CLOSE)

        setTimeout(() => {
            PubSub.dispatch(actionsType.DRAWER.ADDRESS_OPEN, { 
                listId: listId,
                callback: (_address) => {
                    PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_OPEN, {
                        listName: listName,
                        listId: listId,
                    })
                    StorageService.setSecureItem('address', _address)
                    if (_address) {
                        setAddressId(_address.addressId)
                    }
                }
            })
        }, 200)
    }

    const updatePhone = () => {
        PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_CLOSE);

        if(clientUpdateDrawer) {
            setTimeout(() => PubSub.dispatch(actionsType.DRAWER.UPDATE_CLIENT_OPEN,  {
                user: userData,
                callbackSuccess: callbackUpdatePhone,
                callbackGoBack: callbackGoBack
            }), 200);
        } else {
            setTimeout(() => PubSub.dispatch('update_client_open', {
                user: userData,
            }), 0)
        }
    }

    const callbackUpdatePhone = (newData) => {
        if (newData.phone) {
            let updatedUser = {
                email: userData.email,
                firstName: userData.firstName,
                lastName: userData.lastName,
                document: newData.document,
                documentType: "RUT",
                phone: newData.phone,
                homePhone: newData.phone,
                corporateName: null,
                tradeName: null,
                corporateDocument: null,
                stateInscription: null,
                corporatePhone: null,
                isCorporate: false,
                profileCompleteOnLoading: false,
                profileErrorOnLoading: false,
                customerClass: null
            }

            if (!schedulePhone) {
                schedulePhone = newData.phone
                return Promise.resolve()
            } else {
                return UserInfoService.updateUser(updatedUser)
                    .then(response  => {
                        return response
                    })
            }
        } else {
            return Promise.resolve(false);
        }
    }

    const callbackGoBack = () => {
        setTimeout(()=> {
            PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_OPEN,{
                listName: listName,
                listId: listId
            })
        },200)
    }

    const changeFrequency = (value) => {
        setFrequency(value) 
    }

    const changeDeliveryDay = (value) => {
        setDeliveryDaySelected(value) 
    }

    const changeStartDate = (value) => {
        setStartDate(value); 
    }

    const changeShippingWindow = (value) => {
        setShippingWindowSelected(value); 
    }

    const getCardsList = () =>{
        WalletService.getWalletCards()
            .then(data => {
                const _cardList = data?.results
                const _fav = _cardList?.filter(_card => _card.isFavorite)?.[0]

                setCardsList(_cardList)
                setSelectedCard(_fav)
            })
    }

    const setHasChecked = (token) => {
        if (token && token === selectedCard.token) return true
        return false
    }

    const callbackSelected = (_card) => {
        if (!_card) return false
        setSelectedCard(_card)
    }

    const callbackSetCheckbox = (_token) => {
        setSelectedCard(cardsList.find(_card => _card.token === _token))
    }

    const onCheckAuthorization = () => {
        if (addressId && selectedCard?.token) {
            setAuthorization(!authorization)
        }
    }

    const saveConfiguration = () => {
        setIsLoading(true)

        let payload = {
            name: listName,
            scheduleCardTokenPayment: selectedCard?.token,
            scheduleDeliveryDay: deliveryDaySelected?.value,
            scheduleFrequency: frequency?.value,
            schedulePaymentMethod: "CatOneClick",
            schedulePhone: userPhone,
            scheduleSalesChannel: salesChannel,
            scheduleShippingAddress: addressId,
            scheduleShippingMethod: "Despacho a Domicilio",
            scheduleShippingWindow: daysOfWeek?.[deliveryDaySelected?.value]?.deliveryRanges?.[shippingWindowSelected?.value], 
            scheduleStartDate: '2021/12/12',
            scheduleStatus: 1,
        }

        ListService.updateScheduledList(listId, payload)
            .then((response) => {
                if (response.status === 200) {
                    PubSub.dispatch('list_update', () => setIsLoading(false))
                    PubSub.dispatch('list_select', () => setIsLoading(false))
                }

                if (props.data.callback) {
                    props.data.callback(listName)
                }

                PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_CLOSE);
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const goBack = () => {
        PubSub.dispatch(actionsType.DRAWER.SCHEDULED_LIST_CLOSE);
    }

    if (isLoading) return <Loader />

    return (
        <div className={'drawer-container scheduled-list-container'}>
            <div className="drawer-title-wrap">
                <h1 className="drawer-title">Configura la lista como Pedido programado</h1>
            </div>
            <div className={'drawer-scroll'}>
                <div className="container-scheduled-list">
                    <span className="scheduled-list-info">Si alguno de los productos no estuviera disponible al preparar tu pedido, te contactaremos para que nos indiques cómo te gustaría sustituirlo.</span>
                    <div className="form-scheduled-list-info">
                        <div className="input-row">
                            <div className="scheduled-list-input-name-wrapper">
                                <label className="required">Nombre del pedido</label>
                                <input
                                    className="scheduled-list-input-name"
                                    type="text"
                                    name="listName"
                                    value={listName ? listName : ''}
                                    placeholder="Ejemplo: Fin de mes"
                                    onChange={changeListName}
                                />
                            </div>
                        </div>
                    </div>
                    <TitleWithBar title="Modo de entrega"/>
                    <div className="scheduled-list-data">
                        <div className="scheduled-list-update-data">
                            <div className="scheduled-list-update-data-text">
                                <span className="scheduled-list-update-data-text-title">Datos de contacto</span>
                                {userPhone ? <span className="scheduled-list-update-data-text-phone">+56 {userPhone}</span> : ''}
                            </div>
                            <button className="scheduled-list-update-data-button" onClick={updatePhone}>Actualizar</button>
                        </div>
                    </div>
                    <div className="scheduled-list-address-container">
                        <span className="scheduled-list-address-title" >Dirección de entrega</span>
                        {address ? (
                            <span className="scheduled-list-address-info">
                                {address}
                                <button className="scheduled-list-update-address" onClick={updateAddress}>
                                    Cambiar
                                </button>
                            </span>
                        ) : (
                            <span className="scheduled-list-address-info">
                                Aún no tienes direcciones guardadas
                                <button className="scheduled-list-update-address" onClick={updateAddress}>
                                    Crea una dirección
                                </button>
                            </span>
                        )}
                    </div>
                    <div className="scheduled-list-selects-wrapper">
                        <div className="input-wrapper-frequency">
                            <label className="required">Frecuencia de entrega</label>
                            <CustomSelect options={frequencyList} value={frequency} onChange={changeFrequency} />
                        </div>
                        <div className="input-wrapper-delivery-day">
                            <label className="required">Día de entrega</label>
                            <CustomSelect options={shippingWindows} value={deliveryDaySelected} onChange={changeDeliveryDay} />
                        </div>
                        <div className="input-wrapper-start-date">
                            <label className="required">Comienza desde</label>
                            <CustomSelect options={startDateList} value={startDate} onChange={changeStartDate} />
                        </div>
                        <div className="input-wrapper-shipping-window">
                            <label className="required">Horario</label>
                            <CustomSelect options={shippingWindowsPerDay} value={shippingWindowSelected} onChange={changeShippingWindow} />
                        </div>
                    </div>
                    <TitleWithBar title="Medio de pago" />
                    <div className='scheduled-list-cards'>
                        {cardsList?.length ? (
                            cardsList.map((_card) => {
                                return (
                                    <PaymentMethodPrimeItem
                                        card={_card}
                                        key={_card.token}
                                        unique={cardsList.length == 1}
                                        isChecked={setHasChecked(_card.token)}
                                        callbackSelected={callbackSelected}
                                        callbackSetCheckbox={callbackSetCheckbox}
                                    />
                                )
                            })
                        ) : (
                            <AddCardsContent debit={true}/>
                        )} 
                    </div>
                    {cardsList && cardsList.length == 0 && (
                        <div className="scheduled-list-payment-method-disclaimer-wrap">
                            <span className="scheduled-list-payment-method-disclaimer">
                                Al registrar tu tarjeta de manera segura, aceptas que se guarden sus datos y Transbank realizará una
                                validación con un cobro de $50 que luego se devolverá a la misma tarjeta. Solo para medios de pago emitidos
                                en Chile.
                            </span>
                        </div>
                    )} 
                    <div className="input-row">
                        <label className="scheduled-list-terms-container">
                            <Checkbox
                                type={'checkbox'}
                                name={'Terms scheduled list'}
                                checked={authorization}
                                onChange={onCheckAuthorization}
                            />
                            <span className="scheduled-list-terms-span">Autorizo a Cencosud Retail S.A. a realizar los cargos en la tarjeta para las compras de mi Pedido programado. <a href="https://www.jumbo.cl" className="new-link new-link-small scheduled-list-link" target={'_blank'}>Términos y condiciones</a> </span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="drawer-actions actions-scheduled-list">
                <button className="secundary-btn scheduled-list-btn-back" onClick={goBack}>Volver</button>
                <button 
                    className={`primary-btn scheduled-list-btn-save ${authorization ? '' : 'disabled'}`} 
                    onClick={authorization ? saveConfiguration : ()=>{}}
                    disabled={!authorization}>
                    {isLoading ? (
                        <Loader />
                    ): (
                        'Guardar configuración'
                    )}
                </button>
            </div>
        </div>
    )
}

export default ScheduledList